import React from "react";
import { ChevronRight, User, Wallet, Lock, HelpCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

// Mapeamento simples de ícones
const ICONS_MAP = {
  person: <User size={24} color="#75878A" />,
  wallet: <Wallet size={24} color="#75878A" />,
  lock: <Lock size={24} color="#75878A" />,
  "help-circle": <HelpCircle size={24} color="#75878A" />,
};

function MinhaContaCard({ icone, titulo, subtitulo, tela }) {
  const navigate = useNavigate();

  const handlePress = () => {
    if (tela) {
      navigate(tela);
    } else {
      window.alert("Em breve!");
    }
  };

  return (
    <div
      onClick={handlePress}
      className="mt-2 border border-solid border-gray-300 h-[65px] rounded-lg w-11/12 max-w-full mx-auto flex items-center cursor-pointer hover:bg-gray-100 transition"
    >
      {/* Ícone */}
      <div className="ml-5 flex-shrink-0">
        {ICONS_MAP[icone] || null}
      </div>

      {/* Título e subtítulo */}
      <div className="flex flex-col ml-5 space-y-0">
        <p className="text-base font-semibold m-0">{titulo}</p>
        <p className="text-sm font-normal text-gray-600 mt-0 leading-tight">{subtitulo}</p>
    </div>

      {/* Seta */}
      <div className="ml-auto mr-5 flex-shrink-0">
        <ChevronRight size={28} color="#75878A" />
      </div>
    </div>
  );
}

export default MinhaContaCard;
